import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { ChatPanel } from '@/features/chat/ChatPanel';
import { useHeartbeat } from '@/features/heartbeat/useHeartbeat';
import { useAuthStore, selectIsAuthenticated } from '@/stores/auth.store';
import { useActiveCallStore } from '@/stores/active-call.store';
import { useT } from '@/i18n';

/** Main authenticated layout: header + flexible page content + heartbeat. */
export function AppShell(): JSX.Element {
  const t = useT();
  const isAuth = useAuthStore(selectIsAuthenticated);
  const activeScreeningId = useActiveCallStore((s) => s.activeScreeningId);
  useHeartbeat({
    enabled: isAuth,
    screeningId: activeScreeningId ?? undefined,
  });

  // F5-R1a — el chasis del agente al brand: fondo nav-bg (el mismo del
  // NavigatorShell), tinta navy, cuerpo Manrope. Estructura intacta.
  return (
    <div className="min-h-screen bg-nav-bg text-nav-navy font-body flex flex-col">
      <a href="#main" className="skip-link">
        {t('appshell.skipLink')}
      </a>
      <Header />
      <main id="main" className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 py-6">
        <Outlet />
      </main>
      <footer className="text-center text-xs text-nav-slate py-4 border-t border-nav-hair bg-white">
        <p>{t('appshell.footer')}</p>
      </footer>
      <ChatPanel />
    </div>
  );
}
